import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Slide from "@material-ui/core/Slide";
import Button from "components/CustomButtons/Button.js";
import Close from "@material-ui/icons/Close";
import classNames from "classnames";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import javascriptStyles from "assets/jss/material-kit-pro-react/views/componentsSections/javascriptStyles.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";

import {
	LoadingMgs,
	SuccessMessage,
	ErrorMessage,
} from "components/Common/toastify";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import * as Yup from "yup";
import { post } from "../../../../lib/requests";
import MenuItem from "@material-ui/core/MenuItem";
import { useDispatch, useSelector } from "react-redux";
import Loading from "components/Common/loading";
import { setDashboard } from "redux/ducks/CSPDashboardSlice";

const useStyles3 = makeStyles(javascriptStyles);
const useStyles2 = makeStyles(headersStyle);
const useStylesBasics = makeStyles(basicsStyle);

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="down" ref={ref} {...props} />;
});

Transition.displayName = "Transition";

const BillingFrequency = ["Monthly", "Annual"];
const AutoRenew = ["Yes", "No"];
const Terms = ["P1M", "P1Y", "P3Y"];
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const SubscriptionUpdateDialog = ({
	subscriptionDialogOpen,
	setSubscriptionDialogOpen,
	geSubscriptionsData,
}) => {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const classes2 = useStyles2();
	const classes3 = useStyles3();
	const dispatch = useDispatch();
	const classesBasics = useStylesBasics();
	const [billingFrequency, setBillingFrequency] = useState("");
	const [autoRenew, setAutoRenew] = useState("");
	const [term, setTerm] = useState("");
	const subscriptionInfo = useSelector((state) => state.subscription);
	const customerDetails = useSelector((state) => state.customer);
	const [loading, setLoading] = useState(false);

	// form validation rules
	const validationSchema = Yup.object().shape({
		quantity: Yup.string().required("Quantity is required"),
		billing_frequency: Yup.string().required("Billing Frequency is required"),
		billing_term: Yup.string().required("Term is required"),
		auto_renewal: Yup.string().required("Auto Renew is required"),
	});
	const formOptions = { resolver: yupResolver(validationSchema) };

	// get functions to build form with useForm() hook
	const {
		register,
		handleSubmit,
		setError,
		setValue,
		reset,
		getValues,
		formState,
	} = useForm(formOptions);
	const { errors } = formState;

	async function onSubmit(formField) {
		setLoading(true);
		LoadingMgs("Subscription Update", "processing...");
		try {
			formField.subscription_id = subscriptionInfo?.id;
			formField.stockcode = subscriptionInfo?.StockCode;
			formField.auto_renewal = formField.auto_renewal === "Yes" ? true : false;
			await post(
				`/api/subscription/singleupdate/${customerDetails?.tenantId}`,
				formField,
				true
			)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Subscription Update", res.data.records.message);
						if (res.data?.records?.goforcheckout) {
							redirectToCheckout();
						}
					} else {
						ErrorMessage("Subscription Update", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Subscription Update", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Subscription Update", "Something went wrong try again!!");
			setLoading(false);
		}
	}
	const redirectToCheckout = () => {
		dispatch(
			setDashboard({
				ConfirmOrder: true,
				Heading: "Microsoft 365",
				TeamT5Form: false,
				KinetixForm: false,
				CustomerSubscriptionDetails: false,
				AddCustomerSubscription: false,
				selectedDialogData: null,
				OrderSummary: false,
			})
		);
	};

	const cancelSubscription = async () => {
		setLoading(true);
		LoadingMgs("Subscription Cancel", "processing...");
		try {
			await post(
				`/api/subscription/cancel/${customerDetails?.tenantId}`,
				{
					subscription_id: subscriptionInfo?.id,
				},
				true
			)
				.then((res) => {
					if (res.data.success) {
						SuccessMessage("Subscription Cancel", res.data.records.message);
						setSubscriptionDialogOpen(false);
						geSubscriptionsData();
					} else {
						ErrorMessage("Subscription Cancel", res.data.message);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("Subscription Cancel", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("Subscription Cancel", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	useEffect(() => {
		if (subscriptionDialogOpen) {
			const qty = subscriptionInfo?.quantity;
			const billingCycle =
				subscriptionInfo?.billingCycle == "monthly" ? "Monthly" : "Annual";
			const termDuration = subscriptionInfo?.termDuration;
			const autoRenewEnabled = subscriptionInfo?.autoRenewEnabled ? "Yes" : "No";

			setValue("quantity", qty);
			setValue("billing_frequency", billingCycle);
			setValue("billing_term", termDuration);
			setValue("auto_renewal", autoRenewEnabled);

			setBillingFrequency(billingCycle);
			setTerm(termDuration);
			setAutoRenew(autoRenewEnabled);
		}
	}, [subscriptionDialogOpen, subscriptionInfo]);

	const handleBillingFrequency = (event) => {
		setBillingFrequency(event.target.value);
		setValue("billing_frequency", event.target.value);
	};

	const handleAutoRenew = (event) => {
		setAutoRenew(event.target.value);
		setValue("auto_renewal", event.target.value);
	};

	const handleTerm = (event) => {
		setTerm(event.target.value);
		setValue("billing_term", event.target.value);
	};

	return (
		<Dialog
			classes={{
				root: classes3.modalRoot,
				paper: classes3.modal + " " + classes3.updateSubscriptionModal,
			}}
			open={subscriptionDialogOpen}
			TransitionComponent={Transition}
			keepMounted
			onClose={() => setSubscriptionDialogOpen(false)}
			aria-labelledby="classic-modal-slide-title"
			aria-describedby="classic-modal-slide-description">
			<DialogTitle
				id="classic-modal-slide-title"
				disableTypography
				className={classNames(classes3.container, classes3.modalHeader)}>
				<Button
					simple
					className={classes3.modalCloseButton}
					key="close"
					aria-label="Close"
					onClick={() => setSubscriptionDialogOpen(false)}>
					{" "}
					<Close className={classes3.modalClose} />
				</Button>
				<h4 className={classNames(classes3.modalTitle)}>
					Update Subscription Details
				</h4>
			</DialogTitle>
			<DialogContent
				id="classic-modal-slide-description"
				className={classes3.modalBody}>
				<hr />
				<form onSubmit={handleSubmit(onSubmit)} id="accountUpdateForm">
					{loading && (
						<Loading
							width={30}
							height={30}
							className={classesCSStyles.absoluteLoading}
						/>
					)}
					<GridContainer className={loading ? classesCSStyles.loading : ""}>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Quantity
								<span className="text-red-600 mr-2"> * </span>
							</div>
							<CustomInput
								inputProps={{
									placeholder: "Enter your answer here",
									type: "number",
									...register("quantity"),
								}}
								formControlProps={{
									fullWidth: true,
									className: classes2.formControl,
								}}
							/>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.quantity?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Term
								<span className="text-red-600 mr-2"> * </span>
							</div>
							<FormControl fullWidth className={classesBasics.selectFormControl}>
								<Select
									MenuProps={{
										className: classesBasics.selectMenu,
									}}
									classes={{
										select: classesBasics.select,
									}}
									value={term}
									onChange={handleTerm}
									inputProps={{
										id: "billing_term",
										...register("billing_term"),
									}}>
									{Terms.map((item, index) => (
										<MenuItem
											key={index}
											classes={{
												root: classesBasics.selectMenuItem,
												selected: classesBasics.selectMenuItemSelected,
											}}
											value={item}>
											{item}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.billing_term?.message}
							</div>
						</GridItem>
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Billing Frequency <span className="text-red-600 mr-2">* </span>
							</div>
							<FormControl fullWidth className={classesBasics.selectFormControl}>
								<Select
									MenuProps={{
										className: classesBasics.selectMenu,
									}}
									classes={{
										select: classesBasics.select,
									}}
									value={billingFrequency}
									onChange={handleBillingFrequency}
									inputProps={{
										id: "billing_frequency",
										...register("billing_frequency"),
									}}>
									{BillingFrequency.map((item, index) => (
										<MenuItem
											key={index}
											classes={{
												root: classesBasics.selectMenuItem,
												selected: classesBasics.selectMenuItemSelected,
											}}
											value={item}>
											{item}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.billing_frequency?.message}
							</div>
						</GridItem>
						{/* auto renew */}
						<GridItem xs={12} sm={6} md={6} className={classes2.customInput}>
							<div className={classNames(classes2.labelTitleUpdate)}>
								Auto Renew
								<span className="text-red-600 mr-2"> * </span>
							</div>
							<FormControl fullWidth className={classesBasics.selectFormControl}>
								<Select
									MenuProps={{
										className: classesBasics.selectMenu,
									}}
									classes={{
										select: classesBasics.select,
									}}
									value={autoRenew}
									onChange={handleAutoRenew}
									inputProps={{
										id: "auto_renewal",
										...register("auto_renewal"),
									}}>
									{AutoRenew.map((item, index) => (
										<MenuItem
											key={index}
											classes={{
												root: classesBasics.selectMenuItem,
												selected: classesBasics.selectMenuItemSelected,
											}}
											value={item}>
											{item}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<div
								className={classNames(
									"text-red-600 text-xs ml-3 pt-1 ",
									classes2.errorLabel
								)}>
								{errors.auto_renewal?.message}
							</div>
						</GridItem>
					</GridContainer>
				</form>
			</DialogContent>
			<DialogActions className={classes3.modalFooter}>
				{subscriptionInfo?.cancancle && (
					<Button
						color="danger"
						size="sm"
						onClick={() => {
							cancelSubscription();
						}}>
						Cancel Subscription
					</Button>
				)}
				&nbsp;&nbsp;
				<Button
					color="info"
					size="sm"
					form="accountUpdateForm"
					className={classes2.button}
					type="submit"
					disabled={formState.isSubmitting}>
					Save
				</Button>
				<Button
					size="sm"
					onClick={() => {
						setSubscriptionDialogOpen(false);
					}}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default SubscriptionUpdateDialog;
